import { Form, Formik } from 'formik';

import styled from '@emotion/styled';

interface IFormComponent {
  initialValues: any;
  schema: any;
  onSubmit: any;
  children: any;
  className?: any;
}

export const FormComponent: React.FC<IFormComponent> = ({
  initialValues,
  schema,
  onSubmit,
  children,
  className,
}) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={onSubmit}
    >
      <StyledForm className={className}>{children}</StyledForm>
    </Formik>
  );
};

const StyledForm = styled(Form)`
  /* border: 2px solid orange; */
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;

  &.column {
    grid-template-columns: 1fr;
  }

  &.col-smallscreen {
    gap: 2.69rem;
  }

  &.datePicker {
    display: flex;
    grid-column: span 2;
    gap: 1rem;
    /* border: 2px solid yellow; */

    & > button {
      flex-shrink: 0;
      margin-top: 0;
    }

    & > div {
      display: flex;
      width: 100%;
    }
  }

  @media (max-width: 480px) {
    display: flex;
    flex-direction: column;
    /* border: 2px solid yellow; */
    gap: 0rem;
  }
`;
